import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12" data-id="element-134">
      <div className="max-w-6xl mx-auto px-4" data-id="element-135">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-8 pb-8 border-b border-gray-800" data-id="element-136">
          <div className="text-2xl font-heading font-bold text-white flex items-center gap-2" data-id="element-137">
            🏊 NATACIÓN 360™
          </div>

          <div className="flex flex-col sm:flex-row gap-6" data-id="element-138">
            <a href="mailto:contacto@natacion360.com.ar" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-139">
              <Mail className="w-4 h-4" data-id="element-140" /> contacto@natacion360.com.ar
            </a>
            <a href="#" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-141">
              <Instagram className="w-4 h-4" data-id="element-142" /> @natacion360.ar
            </a>
            <a href="#" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-143">
              <Globe className="w-4 h-4" data-id="element-144" /> www.natacion360.com.ar
            </a>
          </div>
        </div>

        <div className="text-center text-sm" data-id="element-145">
          <p className="mb-2" data-id="element-146">
            © NATACIÓN 360™ 2025. Todos los derechos reservados.
          </p>
          <p data-id="element-147">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}